// Händelser: listan med nivå, tid och text, och ägarens svar "Normalt" eller "Bra att veta".
// En händelse "i efterhand" kom fram när navets buffert kom fram efter ett avbrott.
// Svaren sparas i molnet. Inlärningen som använder dem kommer senare (kravspecen §7).

import { datumOchTid, type Handelse, klockslag, type Svar } from "@batkoll/gemensam";
import { Nivamarke } from "../komponenter.tsx";

export function Handelsevy(props: {
  handelser: Handelse[];
  svara: (id: string, svar: Svar) => void;
  sparar: string | null;
  /** Bara ägaren svarar. En läsare ser händelserna. */
  kanSvara?: boolean;
  /** b15: platsen, för en åtgärd som öppnar guiden. */
  platsId?: string | null;
}) {
  const kanSvara = props.kanSvara ?? true;
  if (props.handelser.length === 0) {
    return (
      <div class="tomt">
        <h2>Inga händelser</h2>
        <p>Här visas det som har hänt på platsen, till exempel när landströmmen försvinner.</p>
      </div>
    );
  }
  return (
    <ol class="handelser">
      {props.handelser.map((h) => (
        <li key={h.id} class={`handelse handelse-${h.niva}`}>
          <div class="handelse-topp">
            <Nivamarke niva={h.niva} />
            {h.iEfterhand && <span class="efterhand">I efterhand</span>}
            <time dateTime={new Date(h.tid).toISOString()}>{datumOchTid(h.tid)}</time>
          </div>
          <p class="handelse-text">{h.text}</p>
          {h.atgard && kanSvara && props.platsId && (
            <p>
              <a class="knapp-andra" href={`#plats/${props.platsId}/${h.atgard.vy}`}>
                {h.atgard.text}
              </a>
            </p>
          )}
          <p class="handelse-status">
            {h.avslutad === null
              ? h.niva === "info"
                ? ""
                : "Pågår"
              : h.avslutad !== h.tid
                ? `Slut kl. ${klockslag(h.avslutad)}`
                : ""}
            {h.navLarmade ? " · Navet larmade också" : ""}
          </p>
          <fieldset class="knappar" disabled={!kanSvara}>
            <legend class="dold">Ditt svar</legend>
            {(["normalt", "bra_att_veta"] as const).map((svar) => (
              <button
                key={svar}
                type="button"
                class="knapp-svar"
                aria-pressed={h.svar === svar}
                disabled={props.sparar === h.id}
                onClick={() => props.svara(h.id, svar)}
              >
                {svar === "normalt" ? "Normalt" : "Bra att veta"}
              </button>
            ))}
          </fieldset>
        </li>
      ))}
    </ol>
  );
}
